import Header from '../../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../../utils/Loader';
import Delete from "./Delete";
import Create from "./Create";
import Update from "./Update";
import { Link} from "react-router-dom";

import { useGetLearningOutcomeDetailQuery } from "../../../Services/api";
import {pageUrl,pageSize} from "../../../utils/constants/constants";
export default function Index() {
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const {
        data: getLearningOutcome,
        isLoading: isGetLoading,
      } = useGetLearningOutcomeDetailQuery({ pageUrl, params:  {search,page,pageSize}  });
      const getPrevious= () => {
        setPage(page-1);
        setSearch("");
      }
      const getNext=()=>{
        setPage(page+1);
        setSearch("");
      }
      const findSearch=(e)=>{
        setPage(0);
        setSearch(e.target.value);
      }
      const [learningOutcomeId,setLearningOutcomeId] = useState("");

      if(isGetLoading) return  <Loader></Loader>
      return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Learning Outcome</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Learning Outcome Details</button>
                        </li>
                        <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100" id="profile-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Learning Outcome Deatil Add</button>
                        </li>
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body table-responsive">
                                                <h5 className="card-title">Learning Outcome Details</h5>
                                                <div className='row'>
                                                    <div className='col-lg-8'></div>
                                                    <div className='col-lg-4'>
                                                        <div className="datatable-search pull-right">
                                                            <input className="datatable-input" placeholder="Search..." type="search" title="Search within table" onChange={findSearch}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th className='text-capitalize'>Course</th>
                                                                <th className='text-capitalize'>Element Name</th>
                                                                <th className='text-capitalize'>Learner Notes</th>
                                                                <th className='text-capitalize'>Relevent Videos</th>
                                                                <th className='text-capitalize'>Case Study</th>
                                                                <th className='text-capitalize'>Recommended Study Hours</th>

                                                                <th className='text-capitalize'>action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            getLearningOutcome?.data?.data_array?.map((item) => {
                                                            return (
                                                                <tr key={item.lpd_id}>
                                                                    <th scope="row">{item.lpd_id}</th>
                                                                    <td>{item?.learning_outcome?.course?.course_name}</td>
                                                                    <td>{item?.bullet_point}</td>
                                                                    <td><Link to={item.file_name} target="_blank" className='text-primary'>Note</Link></td>
                                                                    <td>
                                                                        {
                                                                         item?.relevant_videos?.map((video)=>{
                                                                            return(
                                                                            <span>
                                                                                <Link to={video.video} target="_blank">{video.title}</Link><br></br>
                                                                            </span>)
                                                                          })
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                       {item?.case_studies?.map((cases)=>{
                                                                            return(
                                                                            <span>
                                                                                <Link to={cases.file} target="_blank">{cases.title}</Link><br></br>
                                                                            </span>)
                                                                        })
                                                                        }
                                                                    </td>
                                                                
                                                                    <td>{item.study_hours}</td>   
                                                                    <td>
                                                                        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">

                                                                        <div className="btn-group" role="group">
                                                                            <button id="btnGroupDrop1" type="button" className="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            Action
                                                                            </button>
                                                                            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                                                <button className="dropdown-item"  data-bs-toggle="modal" onClick={()=>setLearningOutcomeId(item.lpd_id)} data-id={item.lpd_id} data-bs-target="#fullscreenModal" >
                                                                                    <div className="icon text-info">
                                                                                    <i className="bi bi-pencil-square"></i>
                                                                                        Update
                                                                                    </div>
                                                                                </button>
                                                                               
                                                                                <Link className="dropdown-item"  to={`/edit-article/${item.lpd_id}`} >
                                                                                    <div className="icon text-info">
                                                                                    <i className="bi bi-pencil-square"></i>
                                                                                      Update Article
                                                                                    </div>
                                                                                </Link>
                                                                                <Link className="dropdown-item"  to={`/edit-video/${item.lpd_id}`} >
                                                                                    <div className="icon text-info">
                                                                                    <i className="bi bi-pencil-square"></i>
                                                                                        Update Video
                                                                                    </div>
                                                                                </Link>
                                                                                <Link className="dropdown-item"  to={`/edit-case-study/${item.lpd_id}`} >
                                                                                    <div className="icon text-info">
                                                                                    <i className="bi bi-pencil-square"></i>
                                                                                       Update Case Study
                                                                                    </div>
                                                                                </Link>
                                                                              <Delete id={item.lpd_id} />
                                                                            </div>
                                                                        </div>
                                                                        </div>
                                                                    </td>                                                                 
                                                                </tr>                                            
                                                                )   
                                                            })  
                                                        } 
                                                        </tbody>
                                                </table>                        
                                                <nav aria-label="Page navigation example">
                                                    <ul className="pagination">
                                                    {getLearningOutcome?.data?.currentPage !==0 ? <li className="page-item"><button type="button" className="page-link" onClick={getPrevious}>Previous</button></li> :''}
                                                    <li className="page-item"> {getLearningOutcome?.data?.currentPage+1} </li>                                                  
                                                    <li className="page-item"> of {getLearningOutcome?.data?.totalPages}</li>
                                                    {getLearningOutcome?.data?.currentPage !==getLearningOutcome?.data?.totalPages ? <li className="page-item"><button type="button" className="page-link" onClick={getNext}>Next</button></li>:''}
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                        </div>
                        <Update id={learningOutcomeId}/>
                        <Create />
                    </div>
                </div>
               
            </div>

            </main>
          
        </div>
    );
}
